<template>
  <div id="scroll-target">
    <vs-row class="mb-2">
      <vs-col vs-type="flex" vs-lg="7" vs-sm="12" class="m-0 p-0"> </vs-col>
      <vs-col vs-align="flex-end" vs-lg="5" vs-sm="12" class="m-0 p-0">
        <div class="text-right hidden lg:inline-block" style="float: right">
          <ul class="demo-alignment pb-0" style="float: right">
            <li class="pl-4 border-0 border-solid border-grey">
              <i
                class="fas fa-file-download fa-2x cursor-pointer hover:text-primary"
                @click="onExport()"
              ></i>
            </li>
          </ul>
        </div>
      </vs-col>
    </vs-row>
    <vs-card>
      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :foot-clone="true"
        no-footer-sorting
        :no-provider-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <!-- A custom formatted footer cell for field 'name' -->
        <template #foot()="data">
          <div style="font-weight: bolder; font-size: 1.1rem">
            <b>{{ data.field.foot }}</b>
          </div>
        </template>
      </b-table>
      <!--
      <data-table :columns="columns" :data="data" @onTablePropsChanged="reloadTable"></data-table>
      -->
      <div v-if="showPagination" class="mt-3 text-right">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>

        <div class="mt-3">{{ from }} to {{ to }} of {{ totalRows }} orders</div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import Service from "@/services";
import XLSX from "xlsx"; // import xlsx
export default {
  components: {},
  data: () => ({
    isBusy: false,
    showPagination: false,
    currentPage: 1,
    perPage: 1000,
    totalRows: 0,
    selected: [],
    search: "",
    filter: "",
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    columns: [
      { label: "Referrer", key: "Referrer", sortable: true, foot: "" },
      { label: "Orders", key: "Orders", sortable: true, foot: "" },
      { label: "Paid", key: "Paid", sortable: true, foot: "" },
      { label: "Rate", key: "PaidRatio", sortable: true, foot: "" },
      { label: "Revenue", key: "Revenue", sortable: true, foot: "" },
      { label: "Pending", key: "PaymentPending", sortable: true, foot: "" },
      { label: "Transfer", key: "Transfer", sortable: true, foot: "" },
      { label: "Amount", key: "TransferAmount", sortable: true, foot: "" },
      { label: "Tickets", key: "Tickets", sortable: true, foot: "" }
    ],
    items: []
  }),
  watch: {},
  created() {
    if (this.$route.query.e == "symposium") {
      this.columns[0].label = "FocalPoint";
    }
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      this.filter = e;
      this.search = e;
    }, 500),
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map(key => key + "=" + ctx[key])
            .join("&");

        return Service.Report.referrer(params)
          .then(res => {
            this.data = res.data;

            let footerRow = res.data[res.data.length - 1];
            for (var key in footerRow) {
              if (footerRow.hasOwnProperty(key)) {
                let index = this.columns.findIndex(x => x.key == key);
                if (index >= 0) {
                  this.columns[index].foot = footerRow[key];
                }
              }
            }
            this.data.pop();
            callback(this.data);
          })
          .catch(error => {
            callback([]);
          });
      }, 500);
    },
    onExport() {
      let rows = [];
      let days = [];

      let header = this.columns.map((item, index) => {
        return { text: item.label };
      });

      rows = this.data.map(item => {
        return {
          Referrer: item.Referrer,
          Orders: item.Orders,
          Paid: item.Paid,
          Rate: item.PaidRatio,
          Revenue: item.Revenue,
          Pending: item.PaymentPending,
          Transfer: item.Transfer,
          Amount: item.TransferAmount,
          Tickets: item.Tickets
        };
      });

      let dataExport = {};
      const dataWS = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "referrer_report.xlsx");
      this.$vs.loading.close();
    }
  }
};
</script>

<style lang="scss">
#sector tbody > tr:last-child {
  td {
    font-size: 1.1rem !important;
    font-weight: bold !important;
  }
}
</style>
